const RefreshSvg = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6884_74970)">
      <path
        d="M1 2.5V5.5H4"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10.5V7.5H9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.745 4.99979C10.4914 4.28319 10.0604 3.6425 9.49227 3.1375C8.9241 2.63251 8.23727 2.27968 7.49586 2.11192C6.75445 1.94417 5.98262 1.96696 5.2524 2.17818C4.52219 2.3894 3.85737 2.78215 3.32 3.31979L1 5.49979M12 7.49979L9.68 9.67979C9.14263 10.2174 8.47781 10.6102 7.7476 10.8214C7.01738 11.0326 6.24555 11.0554 5.50414 10.8877C4.76273 10.7199 4.0759 10.3671 3.50773 9.86208C2.93957 9.35709 2.50858 8.7164 2.255 7.99979"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6884_74970">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default RefreshSvg;
